import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtText from "../../../components/NtText";

function NtDevopsSection(props) {
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/devops-intro.png")}
    >
      <View style={{ marginTop: 150, fontWeight: "300" }}>
        <NtSectionTitle style={{ textAlign: "left", fontSize: 28 }}>
          DEV<NtText style={{ fontWeight: "800" }}>OPS</NtText>
        </NtSectionTitle>
        <NtSectionDescription style={{ marginTop: 6 }}>
          Enterprises
        </NtSectionDescription>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 600,
  },
});

export default NtDevopsSection;
